import { AppRoutes } from '../../app.app-manager-routes';
import { EntityManagerInfo } from '../../models/entity-config';

// Censimento delle voci del modulo rendicontazione: solo dati, nessuna EMC (spec 2026-10-19 §5).
// Generato da tools/split-app-manager-routes.mjs; le EMC stanno nel data delle rotte e nelle EMC che aprono le modali.
export class RendicontazioneRoutes {
  static readonly RendicontazioneRapportinoList: EntityManagerInfo = {
    id: 'RendicontazioneRapportinoList',
    name: 'rendicontazionerapportino',
    translateSuffixs: ['generic.', 'rendicontazionerapportino.'],
    url: 'rendicontazionerapportinolist',
    parent: AppRoutes.Rendicontazione
  };
}
